var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadHigh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50781 22.7367H17.4532M4.16538 12.9264C6.24588 14.9158 7.40002 16.0244 9.48052 18.0138M9.48052 18.0138C11.561 16.0244 12.7152 14.9158 14.7957 12.9264M9.48052 18.0138V1.46094",
    stroke: "#FAC300",
    strokeWidth: 2.27792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadHigh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download-high.25916aac8975ea73f0e58af1cb0bd592.svg";